// extracted by mini-css-extract-plugin
export var centerText = "_by-8";
export var container = "_by-0";
export var doughnutContainer = "_by-7";
export var legend = "_by-a";
export var legendItemColorDisplay = "_by-b";
export var legendItemLabel = "_by-d";
export var legendItemValue = "_by-c";
export var lg = "_by-5";
export var maxWidth = "_by-9";
export var md = "_by-4";
export var responsive = "_by-6";
export var sm = "_by-3";
export var xs = "_by-2";
export var xxs = "_by-1";